export default {
	namespaced: true,
	state: {
		type: 'default',
		content: '',
		active: false,
		button: {},
		settings: {
			showBackground: true,
		},
	},
	mutations: {
		setType(state, value) {
			state.type = value
		},
		setContent(state, value) {
			state.content = value
		},
		setButton(state, value) {
			state.button = value
		},
		setSettings(state, value) {
			state.settings = value
		},
		setActive(state, value) {
			state.active = value
		},
	},
	actions: {
		setModal({ commit }, value) {
			// Set modal type
			if (value.type) commit('setType', value.type)
			else commit('setType', 'default')

			// Set modal Content
			if (value.content) commit('setContent', value.content)
			else commit('setContent', '')

			// Set modal Button
			if (value.button) commit('setButton', value.button)
			else commit('setButton', {})

			// Set modal Content
			if (value.settings) commit('setSettings', value.settings)
			else
				commit('setSettings', {
					showBackground: true,
				})

			// Set active state of Modal
			if (value.active) commit('setActive', value.active)

			// Set Active with a timeout
			if (value.timeout) {
				commit('setActive', true)
				setTimeout(() => {
					commit('setActive', false)
				}, value.timeout)
			}
		},
	},
}
